export default {
	$window: $(window),
	$document: $(document),
	$html: $(document.documentElement),
	$body: $(document.body),
	$title: $('title'),
	animationDuration: 0.5,
};
